import React from "react";
import {
  TbEye,
  TbEyeOff,
  TbMail,
} from "react-icons/tb";
import { Link } from "react-router-dom";
import LoginImg from "../../../assets/image/login-bg.jpeg";
import Logo from "../../../assets/svgs/logo";
import {
  Box,
  Button,
  Col,
  Gap,
  InputField,
  Row,
  Typography
} from "../../../ppui";
import { Brand, ContentBox, FooterBox, FromBox, ImageBox, PasswordToggleIcon, ScreenLayout } from "./style";
import useRegistrationService from "./admin-login-service";

const AdminLogin = ({ openSnackbar }) => {

  const { handleSubmit, handleChange, errors, signUpData, handleBlurFn, showPassword, togglePasswordVisibility } = useRegistrationService({ openSnackbar });



  return (
    <>
      <ScreenLayout>
        <ImageBox>
          <img src={LoginImg} alt="Login background" />
        </ImageBox>
        <ContentBox>
          <Brand>
            <Logo />
          </Brand>
          <FromBox>
            <Typography variant="h3" mb={"10"}>
              Admin Login
            </Typography>
            <Typography variant="body2" color="dark" colorVariant="light">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis massa
              lacus, finibus vel tincidunt non, malesuada non turpis.
            </Typography>
            <Gap height={30} />

            <Row>
              <Col sm={12} lg={10} xl={8}>

                <Box pb={22}>
                  <InputField
                    name="email"
                    type="text"
                    label="Email Id"
                    variant="standard"
                    required={true}
                    placeholder="Email"
                    fullWidth
                    labelBold
                    prefix={<TbMail />}
                    value={signUpData?.email}
                    onChange={(e) => handleChange(e.target.value, "email")}
                    helperText={errors.email}
                    error={errors.email}
                    onBlur={(e) => handleBlurFn(e, "email")}
                  />
                </Box>

                <Box pb={22}>
                  <InputField
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    variant="standard"
                    required={true}
                    placeholder="Enter Password"
                    fullWidth
                    labelBold
                    prefix={
                      <PasswordToggleIcon onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                        {showPassword ? <TbEyeOff /> : <TbEye />}
                      </PasswordToggleIcon>
                    }
                    value={signUpData?.password}
                    onChange={(e) => handleChange(e.target.value, "password")}
                    error={errors.password}
                    onBlur={(e) => handleBlurFn(e, "password")}
                    helperText={errors.password}
                  />
                </Box>

                {errors.general && (
                  <Box pb={22}>
                    <Typography color="danger">{errors.general}</Typography>
                  </Box>
                )}

                <Row>
                  <Col md={7}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      block
                      fullWidth
                      onClick={handleSubmit}
                    >
                      Sign Up
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FromBox>

          <FooterBox>
            <Typography variant="body2" color="dark" colorVariant="light">
              For more detailed information please review our{" "}
              <Link color="dark" underline="always" to="/">
                Privacy Policy.
              </Link>{" "}
              Need help?{" "}
              <Link color="dark" underline="always" to="/">
                Contact us
              </Link>
            </Typography>
          </FooterBox>
        </ContentBox>

      </ScreenLayout>

    </>
  );
};

export default AdminLogin;
